import listPage from './listPage';
import addPage from './addPage';

export default {
  ...listPage,
  ...addPage,
};
